<template>
  <div class="meeting">
    <div class="meetinginput">
      <div class="meeting_title">
        <img src="/images/meeting/title.png" />
      </div>
      <div class="meeting_info">
        <div class="meeting_fillin">
          <div class="input_info">姓名</div>
          <input type="text" v-model="name" placeholder="请填写您的姓名" @keyup="getinputvalue" />
        </div>
        <div class="meeting_fillin">
          <div class="input_info">电话号码</div>
          <input type="text" v-model="phone" placeholder="请填写您的电话号码" @keyup="getinputvalue" />
        </div>
        <div class="meeting_fillin">
          <div class="input_info">单位名称</div>
          <input type="text" v-model="unit" placeholder="请填写您的单位名称" @keyup="getinputvalue" />
        </div>
        <div class="meeting_fillin">
          <div class="input_info">邀请人</div>
          <input type="text" v-model="invitepeople" placeholder="请填写您的邀请人" @keyup="getinputvalue" />
        </div>
      </div>
      <button
        :class="isforbid?'meeting_bto':'meetingselect_bto'"
        @click="submitapplication"
        :disabled="isforbid"
      >提交报名</button>
    </div>
    <!-- 弹窗 -->
    <div class="dislog" v-show="isinvite">
      <div class="dislog_window">
        <input type="text" placeholder="请输入邀请码" class="invitecode" v-model="code" />
        <button class="invitebto" @click="submitcode">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { meetinginvitity, invitecode } from "@/apis/meeting";
export default {
  name: "annualmeeting",
  data() {
    return {
      isinvite: true,
      name: "",
      phone: "",
      unit: "",
      invitepeople: "",
      code: "",
      isforbid: true
    };
  },
  computed: {
    all() {
      const {
        name, // 姓名
        phone, // 手机号
        unit, // 单位名称
        invitepeople // 邀请人
      } = this;
      return {
        name, // 姓名
        phone, // 手机号
        unit, // 单位名称
        invitepeople // 邀请人
      };
    }
  },
  methods: {
    // 提交申请
    submitapplication() {
      meetinginvitity({
        name: this.name,
        phone: this.phone,
        unit_name: this.unit,
        inviter: this.invitepeople
      }).then(res => {
        this.$notify({ type: "success", message: "报名成功" });
        window.location.href =
          "https://a3.rabbitpre.com/m2/aUe1Zj4PDx?lc=2&sui=o5_FNs6hxEHJ9gfvl1VwUfv0W4dA#157724493595670";
      });
    },
    // 填写邀请码
    submitcode() {
      if (this.code == "0809") {
        this.isinvite = false;
      } else {
        this.$notify({ type: "warning", message: "邀请码填写错误" });
      }
    },
    // 监听值的变化
    getinputvalue() {
      if (this.name && this.phone && this.unit && this.invitepeople) {
        this.isforbid = false;
      } else {
        this.isforbid = true;
      }
    }
  },
  watch: {
    all(_) {
      this.getinputvalue();
    }
  }
};
</script>

<style scoped>
.meeting {
  background: url("/images/meeting/meettimg.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.meetinginput {
  position: absolute;
  bottom: 5.333vw;
  left: 7.2vw;
  width: 85.6vw;
  height: 108.667vw;
  background-image: linear-gradient(-55deg, #ffc8b3 0%, #ffd7c7 100%),
    linear-gradient(#fecdba, #fecdba);
  background-blend-mode: normal, normal;
  box-shadow: 0vw 0.8vw 0.8vw 0vw rgba(56, 56, 56, 0.42);
  border-radius: 2.667vw;
}
.meeting_title {
  width: 41.333vw;
  height: 6.267vw;
  margin: 6vw auto 4vw;
  display: flex;
  justify-content: center;
}
.meeting_title img {
  width: 100%;
  height: 100%;
}
.input_info {
  font-size: 4vw;
  color: #a01625;
}
.meeting_fillin {
  width: 74.933vw;
  margin: 0 auto 6.667vw;
}
.meeting_fillin:last-child {
  margin-bottom: 6.667vw;
}
.meeting_info input {
  background-color: rgba(56, 56, 56, 0);
  border: none;
  border-bottom: 1px solid rgba(250, 250, 250, 0.5);
  width: 100%;
  height: 5.333vw;
  font-size: 3.467vw;
  margin-top: 2vw;
}
.meeting_bto {
  width: 80.267vw;
  height: 12.533vw;
  background-image: linear-gradient(90deg, #ffcc7c 0%, #e1a342 100%),
    linear-gradient(#595959, #595959);
  background-blend-mode: normal, normal;
  border-radius: 2.667vw;
  opacity: 0.4;
  color: white;
  display: block;
  border: none;
  margin: 0 auto;
}
.meetingselect_bto {
  width: 80.267vw;
  height: 12.533vw;
  background-image: linear-gradient(90deg, #ffcc7c 0%, #e1a342 100%),
    linear-gradient(#595959, #595959);
  background-blend-mode: normal, normal;
  border-radius: 2.667vw;
  color: white;
  display: block;
  border: none;
  margin: 0 auto;
}
/* 弹窗 */
.dislog {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.dislog_window {
  width: 72vw;
  height: 77.333vw;
  border-radius: 2.667vw;
  background: url("/images/meeting/invite.png") no-repeat;
  background-size: 100% auto;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.invitecode {
  position: absolute;
  bottom: 19.067vw;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  width: 63.733vw;
  height: 6.667vw;
  border: none;
  border-radius: 3.333vw;
  color: rgba(199, 199, 204, 1);
  font-size: 3.733vw;
  padding-left: 3.333vw;
}
.invitebto {
  width: 63.733vw;
  height: 10.4vw;
  background-image: linear-gradient(90deg, #6b69fc 0%, #5153f5 100%),
    linear-gradient(#fdfffc, #fdfffc);
  background-blend-mode: normal, normal;
  border-radius: 5.2vw;
  position: absolute;
  bottom: 2.267vw;
  left: 50%;
  transform: translateX(-50%);
  border: none;
  color: white;
  font-size: 3.733vw;
}
</style>
